import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {postSubmit} from "@ui-seeker/utils";

import {WEBBACK_V2_API} from "@constants";
import {isLoadingCommonFilters, commonFiltersValue, isSystemBusy} from "@signals";
import {PriceEvolutionCurrentTabData, PriceEvolutionIsEmpty} from "../@signals";


export default function usePriceEvolutionFilters() {
	const { showToast } = useAppToast()
	const tabs = useSignal([])
	const isSplitBySku = useSignal(true)
	const isPercentage = useSignal(false)
	const startDate = useSignal('')
	const endDate = useSignal('')
	const prevStartDate = useSignal('')
	const prevEndDate = useSignal('')

	useEffect(() => {
		if (isLoadingCommonFilters.value){
			let filters = commonFiltersValue.value
			if (Array.isArray(filters.splitKpi))
				filters.splitKpi = filters.splitKpi[0]
			handleSubmit(filters)
		}
	}, [isLoadingCommonFilters.value])

	const handleSubmit = (filters) => {
		postSubmit(`${WEBBACK_V2_API}/pricing/price-evolution/context`, filters).then(res => batch(() => {
			if (!res.tabs.length)
				PriceEvolutionIsEmpty.value = true
			tabs.value = res.tabs
			isSplitBySku.value = res.isSplitBySku
			isPercentage.value = res.isPercentage
			startDate.value = res.startDate
			endDate.value = res.endDate
			prevStartDate.value = res.prevStartDate
			prevEndDate.value = res.prevEndDate
			PriceEvolutionCurrentTabData.value = res.tabs.filter(tab => tab.id === res.selectedTab)[0] || {}
			batch(() => isLoadingCommonFilters.value = false)
		})).catch(() => batch(() => {
			isLoadingCommonFilters.value = false
			tabs.value = []
			isSystemBusy.value = true
		}))
	}

	return {
		tabs: tabs.value,
		isSplitBySku: isSplitBySku.value,
		isPercentage: isPercentage.value,
		startDate: startDate.value,
		endDate: endDate.value,
		prevStartDate: prevStartDate.value,
		prevEndDate: prevEndDate.value,
	}

}